import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Handbook module.
 * Only static (non-parameterized) routes are listed.
 */
export const HANDBOOK_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/handbook/list',
    labelKey: 'Handbook.list',
    icon: '/assets/tablerIcons/outline/book.svg',
    moduleId: 41,
    groupLabelKey: 'MenuRoutes.group.handbookViews'
  },
  {
    path: '/handbook/read-status',
    labelKey: 'Handbook.readStatus',
    icon: '/assets/tablerIcons/outline/checklist.svg',
    moduleId: 41,
    groupLabelKey: 'MenuRoutes.group.handbookViews'
  }
];
